var _rect, _rect2, _g, _g2, _circle, _rect3, _circle2, _rect4, _circle3, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 188,
    viewBox: "0 0 180 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0456032,
    width: 157.143,
    height: 152.143,
    rx: 12.1429,
    fill: "#042261",
    fillOpacity: 0.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0456032,
    x: 22.8571,
    y: 35.7142,
    width: 157.143,
    height: 152.143,
    rx: 12.1429,
    fill: "#042261",
    fillOpacity: 0.73
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3009_3256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.7143,
    y: 18.5714,
    width: 98.3725,
    height: 145.714,
    rx: 10.7143,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3009_3256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.5714,
    y: 33.5714,
    width: 72.8571,
    height: 15,
    rx: 7.5,
    fill: "white",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8571,
    y: 32.8571,
    width: 74.2857,
    height: 16.4286,
    rx: 8.21429,
    stroke: "#2F3543",
    strokeWidth: 1.42857
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0714,
    cy: 77.5,
    r: 5.35714,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 69.0867,
    y: 70.7142,
    width: 57.8571,
    height: 15,
    fill: "#5A6479"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0714,
    cy: 106.786,
    r: 5.35714,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 69.0867,
    y: 100,
    width: 57.8571,
    height: 15,
    fill: "#5A6479"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0714,
    cy: 136.072,
    r: 5.35714,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 69.0867,
    y: 129.286,
    width: 57.8571,
    height: 15,
    fill: "#5A6479"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3009_3256",
    x: 36.4286,
    y: 16.4286,
    width: 106.944,
    height: 154.286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.42857,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3009_3256"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3009_3256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3009_3256",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3009_3256",
    x: 46.4285,
    y: 30.7143,
    width: 87.1429,
    height: 29.2857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.24446 0 0 0 0 0.270514 0 0 0 0 0.341231 0 0 0 0.369373 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3009_3256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3009_3256",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingViewIcon);
export default __webpack_public_path__ + "static/media/LandingViewIcon.2a8b7811405fe5c02eaf00a4dbe7a8fa.svg";
export { ForwardRef as ReactComponent };